export default function isAbortSignalTimeoutSupported() {
  return typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function'
}
